// Audits page look: two columns on white, desktop first. Class names are
// written out in full so Tailwind can see them. Soft violet only for hover and
// the website matches; strong purple (violet-600) only for small active
// controls. Titles are small grey capitals.

export const AUDITS = {
  page: "h-full flex bg-white",
  // Left: what's coming (Your area, What you have). Right: the Snapshots list.
  side: "w-[34%] max-w-[30rem] shrink-0 border-r border-slate-200 overflow-y-auto px-7 py-6 space-y-8",
  main: "flex-1 min-w-0 overflow-y-auto px-7 py-6",
  title: "text-[0.6875rem] font-semibold text-slate-500 uppercase tracking-wider",
  titleRow: "flex items-baseline justify-between gap-3 mb-3",
  titleCount: "text-xs text-slate-400",

  // Placeholders: quiet, no numbers.
  placeholder: "border border-dashed border-slate-200 rounded-lg px-4 py-5 text-sm text-slate-400",

  // Temporary niche counts check (stage 2 only; stage 3 replaces it).
  checkNiche: "text-[0.8125rem] text-slate-600 border-b border-slate-100 pb-2 space-y-0.5",
  checkMuted: "text-xs text-slate-400",
  checkWarning: "text-xs text-amber-700",

  search: "w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:border-violet-400 bg-white",

  // Website matches, above the list.
  website: "mt-3 border border-violet-100 bg-violet-50/60 rounded-lg px-4 py-3",
  websiteHead: "text-xs text-slate-500",
  websiteDomain: "font-semibold text-slate-800",
  websiteRow: "w-full flex items-center justify-between gap-4 text-left text-sm px-2 py-1.5 -mx-2 rounded-md hover:bg-violet-100",
  websiteName: "font-medium text-slate-800 truncate",
  websiteDate: "text-xs text-slate-400 shrink-0",

  // Niche groups.
  groups: "mt-5 space-y-5",
  groupHead: "w-full flex items-center gap-2 py-1 text-left group",
  chevron: "w-3 text-[0.625rem] text-slate-400 group-hover:text-slate-600",
  groupName: "text-[0.6875rem] font-semibold text-slate-500 uppercase tracking-wider group-hover:text-slate-800",
  groupCount: "text-xs text-slate-400",
  rows: "mt-1 border-t border-slate-100",

  // One snapshot.
  row: "flex items-start gap-4 border-b border-slate-100 hover:bg-violet-50/40",
  rowOpen: "flex-1 min-w-0 text-left px-2 py-2",
  rowTop: "flex items-baseline justify-between gap-4",
  rowName: "text-sm font-semibold text-slate-900 truncate",
  rowDate: "text-xs text-slate-400 shrink-0",
  rowMeta: "flex items-center flex-wrap gap-x-2.5 gap-y-1 mt-0.5",
  rowTitle: "text-[0.8125rem] text-slate-600",
  rowId: "text-xs text-slate-400",
  tag: "text-[0.6875rem] bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded",
  // Stop, for a running snapshot: small, sits at the row's right.
  stop: "shrink-0 self-center mr-2 text-xs font-medium text-slate-600 border border-slate-300 rounded-md px-2 py-1 hover:border-red-300 hover:text-red-700 disabled:opacity-50",

  message: "py-16 text-center text-sm text-slate-400",
  // Empty account: the one strong purple button.
  startButton: "mt-4 inline-block text-sm font-semibold text-white bg-violet-600 hover:bg-violet-700 rounded-lg px-4 py-2",
};
